import React, { Component } from "react";
import "../report-styles/filterView.scss";
import {
  filter_config,
  filter_config_ordered_keys,
  filter_whitelist_detailed_acquisition,
  filter_whitelist_merchant,
  filter_whitelist_assisted_ekyc,
  filter_whitelist_detailed_assisted_ekyc,
  filter_whitelist_attendance_summary,
  app_status_sub_categories,
  filter_whitelist_call_quality,
} from "../Configs/filterConfigs";
import { format } from "date-fns";
import CustomSelect from "./customSelect";
import AxiosClient from "../../../Network/AxiosClient";
import CustomDatePicker from "./customDatePicker";
import TableView from "./tableView";
import { Collapse } from "@material-ui/core";
import DownloadReport from "./downloadReport";
import ExpandLess from "../svgs/expand_less.svg";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import CategorizationUpload from "../../Reports/category/Categorization/categorizationUpload";
import CustomTextField from "./customTextField";
export default class FilterView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: { ...filter_config },
      isFilterCollapsed: true,
      tableData: [],
      filterCount: 0,
      businessUnits: [],
      fetchingTable: false,
      uploadDialogOpen: false,
      synching: false,
    };
  }
  componentDidMount() {
    const userType = JSON.parse(localStorage.getItem("currUserType"));
    const noFilterUserTypes = ["warehouse_manager", "cs_super_user"];
    if (!noFilterUserTypes.includes(userType)) {
      this.iniitiateZonalMapping();
      this.fetchBusinessUnits();
      this.fetchQuizIds();
      this.fetchServiceReferralCampaigns();
    }
  }
  iniitiateZonalMapping = () => {
    this.fetchOptions("cluster", "organizations/api/v1/clusters", "");
    this.fetchOptions("region", "organizations/api/v1/regions", "");
    this.fetchOptions("area", "organizations/api/v1/areas", "");
    this.fetchOptions("territory", "organizations/api/v1/territories", "");
    this.fetchOptions("agency", "organizations/api/v1/agency", "");
    this.fetchOptions(
      "field_force",
      "admin_panel/v1/mdo-list?page_index=0&page_size=10000&filter=yes",
      ""
    );
  };

  fetchServiceReferralCampaigns = () => {
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/referral_service/v1/service-referral-list`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    )
      .then((res) => {
        var temp = [];
        res.data.data.forEach((i) => {
          temp.push({ id: i.campaign_name, name: i.campaign_name });
        });
        this.setState(
          (prevState) => ({
            form: {
              ...prevState.form,
              campaign_name: {
                ...prevState.form["campaign_name"],
                options: [...temp],
              },
            },
          }),
          () => {
            console.log(this.state.form);
          }
        );
      })
      .catch((err) => console.log(err));
  };

  fetchQuizIds = () => {
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/survey/v1/quiz-id-list`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    )
      .then((res) => {
        console.log(res.data.quiz_id_list);
        var temp = [];
        res.data.quiz_id_list.forEach((i) => {
          temp.push({ id: i, name: i });
        });
        this.setState(
          (prevState) => ({
            form: {
              ...prevState.form,
              quiz_id: {
                ...prevState.form["quiz_id"],
                options: [...temp],
              },
            },
          }),
          () => {
            //this.props.callBack({ ...this.state.form });
          }
        );
      })
      .catch((err) => console.log(err));
  };
  fetchBusinessUnits = () => {
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/organizations/api/v1/get-pillar-geography`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    )
      .then((res) => {
        var temp = [];
        Object.keys(res.data).forEach((key) => {
          temp.push({ id: key, name: key, subUnits: [...res.data[key]] });
        });
        // console.log(temp);
        this.setState(
          (prevState) => ({
            businessUnits: res.data,
            form: {
              ...prevState.form,
              business_unit: {
                ...prevState.form["business_unit"],
                options: [...temp],
              },
            },
          }),
          () => {
            //this.props.callBack({ ...this.state.form });
          }
        );
      })
      .catch((err) => console.log(err));
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.report !== this.props.report &&
      prevProps.report &&
      !this.props.report
    ) {
      this.setState({ tableData: [], isFilterCollapsed: true, filterCount: 0 });
      const filter_whitelist = Object.keys(
        prevProps.report.fields.fields
      ).filter((key) => this.state.form.hasOwnProperty(key));
      //console.log(filter_whitelist);
      this.onClearFilters(filter_whitelist);
    }
  }

  handleChange = (e, key) => {
    if (key === "app_status_category") {
      this.regenerateAppSubStatusOptions(e.target.value);
    }
    this.setState(
      (prevState) => {
        const updatedForm = {
          ...prevState.form,
          [key]: { ...prevState.form[key], value: e.target.value },
        };

        if (prevState.form[key] && prevState.form[key].type === "date-picker") {
          const field = prevState.form[key];

          if (field.pairedWithEnd && updatedForm[field.pairedWithEnd]) {
            const dynamicMinDate = e.target.value || field.minDate;
            updatedForm[field.pairedWithEnd] = {
              ...updatedForm[field.pairedWithEnd],
              dynamicMinDate: dynamicMinDate,
            };
          }

          if (field.pairedWithStart && updatedForm[field.pairedWithStart]) {
            const dynamicMaxDate = e.target.value || field.maxDate;
            updatedForm[field.pairedWithStart] = {
              ...updatedForm[field.pairedWithStart],
              dynamicMaxDate: dynamicMaxDate,
            };
          }
        }

        return { form: updatedForm };
      },
      () => {
        this.props.callBack({ ...this.state.form });
        if (this.state.form[key].childApiPoint) {
          const endPoint = this.state.form[key].childApiPoint;
          const param = `?${this.state.form[key].paramTag}=${e.target.value}`;
          this.fetchOptions(this.state.form[key].childKey, endPoint, param);
        }
      }
    );
  };

  generatePostBody = (report) => {
    const form = { ...this.state.form };
    const fields = report.fields.fields;
    var postBody = {};
    var availableKeys =
      report.key === "assisted-ekyc-report"
        ? filter_whitelist_assisted_ekyc[form["filter_type"].value].filter(
            (f) => f !== "filter_type"
          )
        : Object.keys(fields);
    Object.keys(fields)
      .filter((key) => form.hasOwnProperty(key))
      .filter((key) => availableKeys.includes(key))
      .forEach((key) => {
        let fieldValue;

        if (key === "request_types") {
          // even though this is not a multi select, we are treating it as an array to accomodate api expectations
          fieldValue = form[key].value === "" ? null : [form[key].value];
        } else if (key === "l1_action_types" || key === "l2_action_types") {
          fieldValue =
            Array.isArray(form[key].value) && form[key].value?.length === 0
              ? null
              : form[key].value;
        } else {
          fieldValue =
            form[key].type &&
            form[key].type === "date-picker" &&
            form[key].value !== ""
              ? format(new Date(form[key].value), "yyyy-MM-dd")
              : form[key].value;
        }

        postBody = {
          ...postBody,
          [key]: fieldValue,
        };
      });

    return postBody;
  };
  getTableData = (report) => {
    this.setState({ fetchingTable: true });
    var postBody = this.generatePostBody(report);
    var url;
    if (report.key === "download-selfie-report") {
      postBody = {
        ...postBody,
        startDate: postBody.start_time,
        endDate: postBody.end_time,
        appName: "nimontron",
      };
      delete postBody["start_time"];
      delete postBody["end_time"];
      url = `${process.env.REACT_APP_FACE_MATCH_URL}v1/`;
    } else url = process.env.REACT_APP_API_REPORT;
    AxiosClient.get(`${url}${report.url}`, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
      },
      params: {
        ...postBody,
        page_no: 1,
        page_size: 50,
      },
    })
      .then((res) => {
        this.setState(
          {
            tableData:
              report.key === "download-selfie-report"
                ? res.data.report
                : res.data.data,
            fetchingTable: false,
          },
          () => {
            if (this.state.isFilterCollapsed) this.onCollapseFilter();
          }
        );
        //console.log(res.data.data);
      })
      .catch((err) => {
        this.setState({ fetchingTable: false });
        console.log(err);
      });
  };
  syncDevices = () => {
    this.setState({ synching: true });
    AxiosClient.post(
      `${process.env.REACT_APP_API_URL}${this.props.report.action.url}`,
      {},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    )
      .then((res) => {
        alert("Device sync successful");
        console.log("success");
        this.setState({ synching: false });
      })
      .catch((e) => {
        //alert("Something went wrong");
        this.setState({ synching: false });
        console.log(e);
      });
  };
  regenerateSubUnitOptions = (units) => {
    var subUnits = [];

    units.forEach((unit) => {
      this.state.businessUnits[unit].forEach((item) => {
        subUnits.push({ id: item, name: item });
      });
    });

    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        sub_unit: {
          ...prevState.form["sub_unit"],
          options: [...subUnits],
        },
      },
    }));
  };

  regenerateAppSubStatusOptions = (status) => {
    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        app_status_sub_category: {
          ...prevState.form["app_status_sub_category"],
          value: "",
          options: [...app_status_sub_categories[status]],
        },
      },
    }));
  };

  handleMultipleSelectChange = (e, key) => {
    if (key === "business_unit") {
      this.regenerateSubUnitOptions(e.target.value);
    }

    this.setState(
      (prevState) => ({
        form: {
          ...prevState.form,
          [key]: { ...prevState.form[key], value: e.target.value },
        },
      }),
      () => {
        this.props.callBack({ ...this.state.form });
        if (this.state.form[key].childApiPoint) {
          var param = "?"; //`?${this.state.form[key].paramTag}=${e.target.value}`;
          e.target.value.map(
            (i) => (param += `${this.state.form[key].paramTag}=${i}&`)
          );
          param = param.slice(0, -1);
          if (key === "cluster") {
            this.fetchRegions(param);
            this.fetchAreas(param);
            this.fetchTerritories(param);
            this.fetchAgency(param);
            this.fetchFieldForce(`&${param.slice(1)}`);
          } else if (key === "region") {
            this.fetchAreas(param);
            this.fetchTerritories(param);
            this.fetchAgency(param);
            this.fetchFieldForce(`&${param.slice(1)}`);
          } else if (key === "area") {
            this.fetchTerritories(param);
            this.fetchAgency(param);
            this.fetchFieldForce(`&${param.slice(1)}`);
          } else if (key === "territory") {
            this.fetchAgency(param);
            this.fetchFieldForce(`&${param.slice(1)}`);
          } else if (key === "agency") {
            this.fetchFieldForce(`&${param.slice(1)}`);
          }
          //this.fetchOptions(this.state.form[key].childKey, endPoint, param);
        }
      }
    );
  };
  fetchRegions = (param) =>
    this.fetchOptions("region", "organizations/api/v1/regions", param);
  fetchAreas = (param) =>
    this.fetchOptions("area", "organizations/api/v1/areas", param);
  fetchTerritories = (param) =>
    this.fetchOptions("territory", "organizations/api/v1/territories", param);
  fetchAgency = (param) =>
    this.fetchOptions("agency", "organizations/api/v1/agency", param);
  fetchFieldForce = (param) => {
    var fields = this.props.report.fields.fields;
    if (fields.hasOwnProperty("field_force"))
      this.fetchOptions(
        "field_force",
        "admin_panel/v1/mdo-list?page_index=0&page_size=10000&filter=yes",
        param
      );
  };

  onClearFilters = (filters) => {
    //console.log(filters);
    var form = { ...this.state.form };
    var isGeoFilter = false;
    filters.forEach((key) => {
      ///removing the values for the key
      if (!form[key]) return; // Safety check to prevent undefined access

      if (form[key]?.category === "geo_filter") isGeoFilter = true;
      form = {
        ...form,
        [key]: {
          ...form[key],
          value: form[key].type === "multi-select" ? [] : "",
          dynamicMinDate: undefined,
          dynamicMaxDate: undefined,
        },
      };
      //checking if key has any child dependency - then removing fetched options and value

      if (form[key].childKey) {
        const childKey = form[key].childKey;
        //console.log(childKey);
        form = {
          ...form,
          [childKey]: {
            ...form[childKey],
            options: [],
            value: form[key].type === "multi-select" ? [] : "",
            dynamicMinDate: undefined,
            dynamicMaxDate: undefined,
          },
        };
      }
    });

    this.setState({ form: form }, () => {
      if (isGeoFilter) this.iniitiateZonalMapping();
    });
  };

  filterFieldForceDataForAcquisitionReport = (filter_key, data) => {
    if (!this.props.report) return data;
    const reportKey = this.props.report.key;
    if (
      (reportKey === "detail-acquisition-report" ||
        reportKey === "detail-eligible-acquisition-report") &&
      filter_key === "field_force"
    ) {
      return data.filter(
        (o) => !o.mdo_type || o.mdo_type === "MAO" || o.mdo_type === "MDO"
      );
    }
    return data;
  };

  fetchOptions = (key, endpoint, param) => {
    // console.log(key, this.props.report);
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/${endpoint}${param}`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      }
    )
      .then((res) => {
        //console.log(key);
        const data = this.filterFieldForceDataForAcquisitionReport(
          key,
          res.data.data
        );
        //console.log("In fucn--->", data);
        this.setState(
          (prevState) => ({
            form: {
              ...prevState.form,
              [key]: {
                ...prevState.form[key],
                options: [...data],
              },
            },
          }),
          () => {
            this.props.callBack({ ...this.state.form });
          }
        );
      })
      .catch((err) => console.log(err));
  };

  onCollapseFilter = () => {
    this.filterCount();
    this.setState((prevState) => ({
      isFilterCollapsed: !prevState.isFilterCollapsed,
      //filterCount: this.filterCount(),
    }));
  };

  onAllFilterClear = () => {
    const filter_whitelist = this.props.report
      ? this.props.report.fields
        ? Object.keys(this.props.report.fields.fields)
        : []
      : [];
    this.onClearFilters(filter_whitelist);
  };

  filterCount = () => {
    var form = { ...this.state.form };
    var filled = Object.keys(form).filter((f) => {
      if (form[f].value.length === 0) return false;
      return true;
    });

    this.setState({ filterCount: filled.length });
  };

  isDownloadDisabled = () => {
    if (!this.props.report || !this.props.report.fields) return true;
    //if (this.props.report.isGeneratable) return false;
    var flag = false;
    var fields = this.props.report.fields.fields;

    var form = { ...this.state.form };

    var availableKeys =
      this.props.report.key === "assisted-ekyc-report"
        ? filter_whitelist_assisted_ekyc[this.state.form["filter_type"].value]
        : this.props.report.key === "assisted-ekyc-report-detailed"
          ? filter_whitelist_detailed_assisted_ekyc[
              this.state.form["filter_type"].value
            ]
          : this.props.report.key === "call-quality-report"
            ? filter_whitelist_call_quality[
                this.state.form["call_quality_report_type"].value
              ]
            : Object.keys(this.props.report.fields.fields); ////safeguard conditional filtering is_required

    Object.keys(fields)
      .filter((key) => availableKeys.includes(key)) //safeguard conditional filtering is_required
      .filter((key) => {
        if (
          form[key] &&
          form[key].dependant &&
          form[key].value.length > 0 && //if parent value is selected then children should be selected too
          form[form[key].dependant].value.length === 0
        ) {
          flag = true;
        }
        return true;
      })
      .filter((key) => {
        return fields[key].is_required;
      })
      .filter((key) => {
        return form.hasOwnProperty(key);
      })
      .forEach((key) => {
        if (form[key].value.length === 0) flag = true;
      });

    return flag;
  };

  generateFilterWhiteList = () => {
    //overriding the filters from api
    if (this.props.report && this.props.report.fields) {
      if (this.props.report.key === "trn-report") {
        return filter_whitelist_merchant[this.state.form["report_type"].value];
      } else if (
        this.props.report.key === "detail-acquisition-report" ||
        this.props.report.key === "detail-eligible-acquisition-report"
      ) {
        return filter_whitelist_detailed_acquisition[
          this.state.form["acquisition_report_type"].value
        ];
      } else if (this.props.report.key === "assisted-ekyc-report") {
        return filter_whitelist_assisted_ekyc[
          this.state.form["filter_type"].value
        ];
      } else if (this.props.report.key === "call-quality-report") {
        return filter_whitelist_call_quality[
          this.state.form["call_quality_report_type"].value
        ];
      } else if (this.props.report.key === "assisted-ekyc-report-detailed") {
        return filter_whitelist_detailed_assisted_ekyc[
          this.state.form["filter_type"].value
        ];
      } else if (this.props.report.key === "attendance-summary-report") {
        return filter_whitelist_attendance_summary[
          this.state.form["attendance_summary_report_type"].value
        ];
      }
    }

    //from report filters api
    return this.props.report
      ? this.props.report.fields
        ? Object.keys(this.props.report.fields.fields)
        : []
      : [];
  };

  toggleUploadModal = () => {
    this.setState((prevState) => ({
      uploadDialogOpen: !prevState.uploadDialogOpen,
    }));
  };

  render() {
    const form = { ...this.state.form };
    const isDisabled = this.isDownloadDisabled();

    const filter_whitelist = this.generateFilterWhiteList();
    const orderedFilterWhiteList = filter_config_ordered_keys.filter((key) =>
      filter_whitelist.includes(key)
    );

    const typeFilters = orderedFilterWhiteList.filter(
      (key) => form[key]?.category === "type_filter"
    );
    const categoryFilters = orderedFilterWhiteList.filter(
      (key) => form[key]?.category === "category_filter"
    );
    const dateFilters = orderedFilterWhiteList.filter(
      (key) => form[key]?.category === "date_filter"
    );

    const geoFilters = orderedFilterWhiteList.filter(
      (key) => form[key]?.category === "geo_filter"
    );

    const entityFilters = orderedFilterWhiteList.filter(
      (key) => form[key]?.category === "entity_filter"
    );

    return (
      <div className="filter-view-container">
        {orderedFilterWhiteList.length > 0 && (
          <FilterHeader
            onAllClear={this.onAllFilterClear}
            onCollapse={this.onCollapseFilter}
            isCollapsed={this.state.isFilterCollapsed}
            filterCount={this.state.filterCount}
          />
        )}
        <Collapse in={this.state.isFilterCollapsed}>
          <div className="filter-categories-row">
            {typeFilters.length > 0 && (
              <FilterCategory
                filters={typeFilters}
                form={form}
                handleChange={this.handleChange}
                handleMultipleSelectChange={this.handleMultipleSelectChange}
                title={"GENERAL"}
                onClearFilters={this.onClearFilters}
                fields={this.props.report?.fields ?? null}
                report={this.props.report}
              />
            )}
            {categoryFilters.length > 0 && (
              <FilterCategory
                filters={categoryFilters}
                form={form}
                handleChange={this.handleChange}
                handleMultipleSelectChange={this.handleMultipleSelectChange}
                title={"CATEGORY"}
                onClearFilters={this.onClearFilters}
                fields={this.props.report?.fields ?? null}
                report={this.props.report}
              />
            )}
            {dateFilters.length > 0 && (
              <FilterCategory
                filters={dateFilters}
                form={form}
                handleChange={this.handleChange}
                handleMultipleSelectChange={this.handleMultipleSelectChange}
                title={"DATE FILTERS"}
                onClearFilters={this.onClearFilters}
                fields={this.props.report?.fields ?? null}
                report={this.props.report}
              />
            )}
            {geoFilters.length > 0 && (
              <FilterCategory
                filters={geoFilters}
                form={form}
                handleChange={this.handleChange}
                handleMultipleSelectChange={this.handleMultipleSelectChange}
                title={"GEO FILTERS"}
                onClearFilters={this.onClearFilters}
                fields={this.props.report?.fields ?? null}
                report={this.props.report}
              />
            )}
            {entityFilters.length > 0 && (
              <FilterCategory
                filters={entityFilters}
                form={form}
                handleChange={this.handleChange}
                handleMultipleSelectChange={this.handleMultipleSelectChange}
                title={"GEO FILTERS"}
                onClearFilters={this.onClearFilters}
                fields={this.props.report?.fields ?? null}
                report={this.props.report}
              />
            )}
          </div>
          <div className="filter-view-button-container">
            {this.props.report && this.props.report.action && (
              <button onClick={this.syncDevices} className="sync-button">
                {this.state.synching ? (
                  <CircularProgress size={14} style={{ color: "white" }} />
                ) : (
                  "Sync Devices"
                )}
              </button>
            )}
            {this.props.report &&
              this.props.report.key === "categorization-report" &&
              this.props.report.isGeneratable && (
                <button
                  onClick={this.toggleUploadModal}
                  className="upload-categorization"
                >
                  Upload
                </button>
              )}

            {this.props.report && this.props.report.url && (
              <DownloadReport
                report={this.props.report}
                form={this.state.form}
                isDisabled={isDisabled}
              />
            )}
            <Dialog
              onClose={this.toggleUploadModal}
              open={this.state.uploadDialogOpen}
              maxWidth="lg"
            >
              <CategorizationUpload />
            </Dialog>

            {/* <button className="download-report" disabled={isDisabled}>
              Download
            </button> */}
            {this.props.report && this.props.report.viewReport && (
              <button
                onClick={() => this.getTableData(this.props.report)}
                disabled={
                  isDisabled ||
                  (this.props.report && !this.props.report.viewReport)
                }
              >
                {!this.state.fetchingTable ? (
                  "View Report"
                ) : (
                  <CircularProgress size={14} style={{ color: "white" }} />
                )}
              </button>
            )}
          </div>
        </Collapse>
        {this.state.tableData.length > 0 && (
          <div className="new-report-table-container">
            <TableView data={this.state.tableData} report={this.props.report} />
          </div>
        )}
      </div>
    );
  }
}

function FilterCategory({
  filters,
  form,
  handleChange,
  handleMultipleSelectChange,
  title,
  onClearFilters,
  fields,
  report,
}) {
  return (
    <div className="category-container">
      <div className="header">
        <h4 className="title">{title}</h4>
        <p className="clear-button" onClick={() => onClearFilters(filters)}>
          Clear
        </p>
      </div>

      {filters.map((key) => {
        var item = { ...form[key] };

        if (item.type === "date-picker") {
          if (
            item.pairedWithEnd &&
            form[item.pairedWithEnd] &&
            form[item.pairedWithEnd].value
          ) {
            item.dynamicMaxDate = form[item.pairedWithEnd].value;
          }

          if (
            item.pairedWithStart &&
            form[item.pairedWithStart] &&
            form[item.pairedWithStart].value
          ) {
            item.dynamicMinDate = form[item.pairedWithStart].value;
          }
        }

        return item.type === "date-picker" ? (
          <CustomDatePicker
            item={item}
            onChangeDate={(e) => handleChange({ target: { value: e } }, key)}
            fields={fields}
            key={key}
            parserStatus={report.parserStatus}
            reportKey={report.key}
            report={report}
            form={form}
          />
        ) : item.type === "multi-select" ? (
          <CustomSelect
            item={item}
            handleChange={(e) => handleMultipleSelectChange(e, key)}
            key={key}
            isMultiSelect={true}
            fields={fields}
          />
        ) : item.type === "text-field" ? (
          <CustomTextField
            item={item}
            handleChange={(e) => handleChange({ target: { value: e } }, key)}
            key={key}
            fields={fields}
          />
        ) : (
          <CustomSelect
            item={item}
            handleChange={(e) => handleChange(e, key)}
            key={key}
            fields={
              fields &&
              item.parentDependant &&
              form[item.parentDependant].value.length > 0
                ? {
                    fields: {
                      ...fields.fields,
                      [key]: { is_required: true }, //all this mumbo jumbo for making is_required true.very bad
                    },
                  }
                : fields
            }
          />
        );
      })}
    </div>
  );
}

function FilterHeader({ onAllClear, onCollapse, isCollapsed, filterCount }) {
  return (
    <div className="filter-title-bar-container">
      <div className="filter-title-bar">
        <p onClick={onCollapse}>
          Filters
          {filterCount > 0 && !isCollapsed && (
            <b className="filter-count">+{filterCount}</b>
          )}
        </p>
        <div className="filter-actions">
          <p onClick={onAllClear}>Clear All</p>
          <span onClick={onCollapse}>
            {isCollapsed ? "Collapse" : "Expand"}
            <img
              src={ExpandLess}
              alt="collapse-icon"
              style={{
                transform: isCollapsed ? "rotateZ(0deg)" : "rotateZ(180deg)",
              }}
            />
          </span>
        </div>
      </div>
    </div>
  );
}
